const {findArguments} = require("../util/ParserHelpers");
const ArrowDraw = require("../../util/ArrowDraw");
const ColorUtil = require("../../util/ColorUtil");

const directions = ["north", "east", "south", "west"];

const rotationArrowParser = function(ps) {
	const reqArgs = findArguments(ps, 4);

	if (!reqArgs) {
		ps.pushError("botSprite requires a sprite name");
		return false;
	}

	const start = reqArgs[0].text;
	const end = reqArgs[1].text;
	const rotDir = reqArgs[2].text;
	const fillColor = reqArgs[3].text;

	const possibleDirections = directions.join(", ");

	if (!directions.includes(start)) {
		ps.pushError(
			`"${start}" is not a valid starting direction. Must be one of ${possibleDirections}`
		);
		return false;
	}

	if (!directions.includes(end)) {
		ps.pushError(
			`"${end}" is not a valid ending direction. Must be one of ${possibleDirections}`
		);
		return false;
	}

	if (rotDir !== "cw" && rotDir !== "ccw") {
		ps.pushError("Rotation direction must be either cw or ccw");
		return false;
	}

	const diagramColors = ColorUtil.getDiagramColors();
	const realColor = diagramColors[fillColor];
	// Checking for a valid color, but spitting out the error message using the color the user input
	if (!realColor) {
		ps.pushError(`"${fillColor}" is not a valid color`);
		return false;
	}

	return {
		type: "rotationArrow",
		start,
		end,
		rotDir,
		color: realColor,
	};
};

const getAngleForDirection = function(dir) {
	if (dir === "north") {
		return 1.5 * Math.PI;
	} else if (dir === "east") {
		return 0;
	} else if (dir === "south") {
		return 0.5 * Math.PI;
	} else if (dir === "west") {
		return Math.PI;
	}
	return 0;
};

const rotationArrowNode = {
	draw(rc, x, y, node, measure) {
		const {start, end, rotDir, color} = node;
		const {width, top, fontSize} = measure;

		const rect = {
			x: x,
			y: y - top,
			w: width,
			h: width,
		};

		const centerX = rect.x + rect.w / 2;
		const centerY = rect.y + rect.h / 2;
		let startAngle = getAngleForDirection(start);
		let endAngle = getAngleForDirection(end);
		if (start === end) {
			endAngle = startAngle - 2 * Math.PI;
			if (rotDir === "ccw") {
				startAngle -= 0.2 * Math.PI;
			} else {
				startAngle += 0.2 * Math.PI;
			}
		}
		const ctx = rc.context;
		const lineWidth = fontSize / 5;
		const radiusFromCenter = rect.w / 3;

		ArrowDraw.drawRotationArrow(ctx, {
			centerX,
			centerY,
			end,
			startAngle,
			endAngle,
			radiusFromCenter,
			isCCW: rotDir === "ccw",
			fontSize,
			lineWidth,
			strokeStyle: color,
			fillStyle: color,
		});
	},

	measure(rc, fontInfo, props, node) {
		const fontSize = fontInfo.size;
		return {
			width: fontSize * 2,
			top: fontSize,
			bottom: fontSize,
			fontSize,
		};
	},
	readAloud: "",
};

module.exports = {
	parsers: {
		mathCommands: {
			rotationArrow: rotationArrowParser,
		},
	},
	nodes: {
		rotationArrow: rotationArrowNode,
	},
};
